import { ILinkData } from "@pageBuilder/typings";

export class LinkRenderer {

    public render(linkElement: HTMLAnchorElement, data?: ILinkData): HTMLElement {
        if (!linkElement || !data) {
            return linkElement;
        }

        linkElement.setAttribute("link-data-type", data.type);

        switch (data.type) {
            case "page":
                linkElement.href = data.value.startsWith("/") ? data.value : `/${data.value}`;
                linkElement.target = data.target;
                break;

            case "url":
                linkElement.href = data.value;
                linkElement.target = data.target;
                break;

            case "document":
                linkElement.href = data.value;
                linkElement.setAttribute("download", "");
                linkElement.removeAttribute("target");
                break;

            default:
                linkElement.href = data.value;
                linkElement.removeAttribute("target");
        }

        return linkElement;
    }

}
